/**
 * https://tc39.es/ecma262/#sec-tostring-applied-to-the-number-type
 */
export function NumberToString(m: number): string {
	return m + "";
}
